import { Typography } from "@mui/material";

export function PageNotFound() {
  return (
    <Typography variant="h5" fontWeight="bold" color="error">
      404, Page Not Found !
    </Typography>
  );
}
